import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const BackToDashboard = ({ label = "Back to dashboard" }) => (
  <div className="mb-4">
    <Link
      to="/dashboard"
      data-testid="back-to-dashboard"
      className="inline-flex items-center gap-1 text-sm text-zinc-600 hover:text-zinc-950 transition-colors"
    >
      <ArrowLeft size={14} /> {label}
    </Link>
  </div>
);
